
const getList = state => state.list
const getAppointments = state => state.appointments
const getAvailableAppointments = state => state.availableAppointments
const getAppointmentsSurgerycenter = state => state.appointmentsSurgeryCenter
const getProposedSurgeries = state => state.proposedSurgeries
const getSurgeries = state => state.surgeries
const getAnesthesia = state => state.anesthesia

export default {
  getList,
  getAppointments,
  getAvailableAppointments,
  getAppointmentsSurgerycenter,
  getProposedSurgeries,
  getSurgeries,
  getAnesthesia
}



// WEBPACK FOOTER //
// ./src/store/modules/schedule/getters.js